export default __webpack_public_path__ + "static/media/bench-window-seat.7252e4c5.webp";